export default function DownloadCTA() {
  return (
    <section id="download" className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">立即下载91抖音APP</h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
          随时随地刷短视频，发现更多精彩内容。支持iOS和Android，免费下载体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-600 text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all">
            <i className="ri-apple-fill text-xl"></i>
            App Store 下载
          </a>
          <a href="#" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-900 transition-all">
            <i className="ri-android-fill text-xl"></i>
            Android 下载
          </a>
        </div>
        <div className="mt-8 flex items-center justify-center gap-6 text-xs text-background-50/70">
          <span className="flex items-center gap-1"><i className="ri-shield-check-line"></i>安全下载</span>
          <span className="flex items-center gap-1"><i className="ri-smartphone-line"></i>iOS/Android</span>
          <span className="flex items-center gap-1"><i className="ri-download-2-line"></i>免费安装</span>
        </div>
      </div>
    </section>
  );
}